<template>
  <div v-show="isShow" :style="domStyle" class="alarm">
    <audio ref="audio" loop="loop"></audio>
    <span class="header" ref="mycolor">
      <!-- :row-class-name="rowClassName" -->
      <Table
        ref="tables"
        highlight-row
        @on-cell-click="cellClick"
        size="small"
        :loading="loading"
        @on-row-click="doblueClick"
        @on-row-dblclick="doubleClickAck"
        :row-class-name="rowClassName"
        :columns="columns"
        :data="alarmData"
        :disabled-hover="true"
        :height="tableHeight"
      ></Table>
      <Page
        :total="dataCount"
        :current="currentPage"
        :page-size="pageSize"
        size="small"
        class="paging"
        @on-change="changepage"
      ></Page>
    </span>
    <Modal
      v-model="alarmModal"
      :title="alarmModalTitle"
      :mask-closable="false"
      draggable
      class-name="vertical-center-modal"
      class="fvalarm"
    >
      <Card class="clearfix" :dis-hover="true" :bordered="false">
        <Form
          :label-width="90"
          inline
          v-if="
            this.singleAlarmData[0] != null &&
            typeof this.singleAlarmData[0] != 'undefined' &&
            this.singleAlarmData[0] != 0
          "
        >
          <Row>
            <Col span="6">
              <FormItem label="报警序号">
                <i-input :readonly="true" v-model="singleAlarmData[0]['almId']"></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="点名">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['tagName']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="优先级">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almPrio']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="标签">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almRemark']"
                ></i-input>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
              <FormItem label="开始时间">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almTime']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="结束时间">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['endTime']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="确认时间">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['ackTime']"
                ></i-input>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="6">
              <FormItem label="点描述">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almDesc']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="报警状态">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almStatus']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="报警组">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almGroup']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="报警类型">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['almType']"
                ></i-input>
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col span="8">
              <FormItem label="报警开始值">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['startValue']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="报警结束值">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['endValue']"
                ></i-input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="报警确认值">
                <i-input
                  :readonly="true"
                  v-model="singleAlarmData[0]['ackValue']"
                ></i-input>
              </FormItem>
            </Col>
          </Row>

          <FormItem label="报警内容">
            <i-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              style="width: 330px"
              :readonly="true"
              v-model="singleAlarmData[0]['almInfo']"
            ></i-input>
          </FormItem>
          <FormItem label="评论内容">
            <i-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              style="width: 330px"
              v-model="singleAlarmData[0]['almComment']"
            ></i-input>
          </FormItem>
          <FormItem label="用户">
            <i-input
              :readonly="true"
              v-model="singleAlarmData[0]['user']"
              style="width: 330px"
              placeholder="请输入确认人..."
            ></i-input>
          </FormItem>
        </Form>
      </Card>
      <div slot="footer" style="display: flex; justify-content: flex-end">
        <Button style="width: 70px" size="large" long @click="unConfirmAlarm">{{
          unConfirmText
        }}</Button>
        <Button
          style="width: 70px"
          type="primary"
          size="large"
          long
          @click="confirmAlarm"
          >{{ confirmText }}</Button
        >
      </div>
    </Modal>
    <!-- <button style="display: none" @click="audioPlay">播放音频</button> -->
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>

<style>
.paging {
  float: right;
  margin-top: 5px;
  white-space: nowrap;
  display: flex;
}

.header {
  --unbgColor: #fff;
  --unColor: #000;
  --bgColor: #fff;
  --Color: #000;
  --thColor: #f8f8f9;
  --tableColor: #f8f8f9;
  --borderColor: #000;
  --textColor: #000;
  --rebgColor: #fff;
  --reColor: #000;
  --reunColor: #000;
  --reunbgColor: #fff;
}
/* .alarm .ivu-table-header table thead tr span,
.alarm .ivu-table-body .ivu-table-tbody tr span {
  /* white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis; 
} */
.alarm .ivu-table-body .ivu-table-tbody tr.ivu-table-row-highlight td {
  background-color: #ebf7ff !important;
}
.alarm .ivu-table-body .ivu-table-tbody tr.ivu-table-row-highlight td .ivu-table-cell {
  height: 18px;
}
/* 未确认 */
.alarm .demo-table-unConfirm-row td {
  color: var(--unColor);
  background-color: var(--unbgColor);
}
/* 已确认已恢复 */
.alarm .demo-table-confirm-row td {
  color: var(--Color);
  background-color: var(--bgColor);
}
.alarm .ivu-table-wrapper .ivu-table .ivu-table-body tr td.selected {
  box-shadow: 2px 2px 5px #333333;
}
/* 恢复 */
.alarm .demo-table-recovery-row td {
  color: var(--reColor);
  background-color: var(--rebgColor);
}

.alarm .demo-table-unRecovery-row td {
  color: var(--reunColor);
  background-color: var(--reunbgColor);
}

.alarm .header .ivu-table th {
  background-color: var(--thColor);
  color: var(--textColor);
}

.alarm .header .ivu-table {
  background-color: var(--tableColor);
}

.alarm .header .ivu-page-next {
  background-color: var(--tableColor);
}

.alarm .header .ivu-page-prev {
  background-color: var(--tableColor);
}

.alarm .header .ivu-page-item {
  background-color: var(--tableColor);
}

.alarm .header .ivu-table:after {
  background-color: transparent;
}

.alarm .header .ivu-table:before {
  background-color: transparent;
}

.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}

/*用于清除浮动*/
.clearfix:after {
  clear: both;
}

.clearfix {
  *zoom: 1;
  /*IE/7/6*/
}

.fvalarm .ivu-modal-content {
  width: 1000px !important;
}

/* 边框为其进行隐藏 */
.header .ivu-table-wrapper {
  border: none;
}

.header .ivu-table th {
  border: none;
}

.header .ivu-table td {
  border-color: var(--borderColor);
}

.v-transfer-dom .vertical-center-modal {
  z-index: 9999 !important;
}
</style>
<script>
import Print from "print-js";
import $ from "jquery";
export default {
  name: "",
  props: ["primitives", "fvSystemApi", "parentObject"],
  created: function () {
    this.defaultTailoring = this.parentObject.defaultTailoring;
    this.windowSize = this.parentObject.windowSize;
    //组件数据混淆
    this.mixin(this.primitives);
    //组件大小位置初始化
    this.domStyle = {
      position: "absolute",
      left: this.x + "px",
      top: this.y + "px",
      width: this.width + "px",
      height: this.height + "px",
    };
    this.enableStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0px",
      backgroundColor: "#ccbfbf",
      opacity: "0.5",
    };
    this.modelsPath = this.parentObject.modelsPath.slice(0);
    this.modelsPath.push(this.registerName);
    this.$store.registerModule(this.modelsPath, {
      state: {
        $: this,
      },
    });
    if (this.alarmType == false) {
      this.UpDateData();
    }
  },
  mounted() {
    this.func();
    this._getAlmCount();
  },
  watch: {
    alarmData(val) {
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        if (element.almStatus == "确认") {
          // this.$refs.audio.setAttribute("src","");
          this.arr.splice(index, 1);
        }
      }
      // console.log(this.arr);
    },
  },
  data: function () {
    return {
      loading: false,
      //是否可用
      isEnable: false,
      //是否显示
      isShow: true,
      playFlag: true,
      timer: null,
      //组件大小位置,在created(创建完毕，挂载前)函数中初始化
      domStyle: {},
      columns: [],
      arr: [],
      column: [],
      alarmData: [],
      openFlag: true,
      singleAlarmData: [],
      isFilter: false, // 是否需要过滤数据
      alarmModal: false, // 确认报警弹窗
      queries: [], //过滤字段
      queryList: [], //过滤列
      tableHeight: 0,
      CurCol1: 0, //单元格列数
      CurRow1: 0, //表格单元格行数
      pageSize: 5,
      currentPage: 1, // 当前页数
      dataCount: 0, // 总条数
      alarmModalTitle: this.fvSystemApi.getResource("确认报警") || "确认报警", //确认报警
      unConfirmText: this.fvSystemApi.getResource("取消") || "取消", //取消
      confirmText: this.fvSystemApi.getResource("确定") || "确定", //取消
      seletRowData: {},
      viewVersion: "10.0.3.3",
    };
  },
  methods: {
    /*
                参数：src 原json数据
                作用：混淆数据到当前对象
            */
    mixin(src) {
      for (var key in src) {
        this[key] = src[key];
      }
    },
    /*
                参数：e 鼠标信息
                     domScale 窗口放大、缩小、偏移等信息
                作用：鼠标事件调用函数，无必要可不进行任何处理
            */
    doFixedEvent(e, domScale) {},
    /*
                参数：无
                作用：系统周期调用
            */
    onTimer() {
      if (this.isEnable) return;
      if (this.alarmType !== true) return;
      var curTime = new Date().getTime();
      if (curTime - this.lastTime < this.alarmstepTime) return;
      this.lastTime = curTime;
      this.UpDateData();
    },
    /*
                参数：无
                作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
            */
    onClose() {
      return new Promise((resolve) => {
        resolve();
      });
    },
    /*
                参数：scaleObj 重绘信息
                作用：组件需要重绘时触发
            */
    reDraw(scaleObj) {
      if (this.fontSize) {
        this.domStyle.fontSize = 12 * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy + "px";
      }
      this.domStyle.left =
        parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + "px";
      this.domStyle.top =
        parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) +
        scaleObj.titleHeight +
        "px";
      this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
      this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
      this.realWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom));
      this.tableHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) - 29;
      this.setColumnsData();
    },
    /*
                参数：isShow 显示隐藏
                作用：设置组件整体显隐
            */
    Show: function (isShow) {
      this.isShow = isShow ? true : false;
    },
    /*
                参数：isEnable 是否可用
                作用：设置组件是否可用
            */
    Enable: function (isEnable) {
      this.isEnable = isEnable ? false : true;
    },
    /*
                 参数：无
                 作用：获取当前报警类型
             */
    GetDateAlarmType() {
      var str = "";
      var backNum;
      if (this.alarmType == false) {
        str = "历 史 报 警";
        backNum = 1;
      } else {
        str = "实 时 报 警";
        backNum = 0;
      }
      //注释掉，暂时不知道用途
      //   this.$Notice.success({
      //     title: "当前报警类型为:",
      //     desc: `${str}`,
      //     render: (h) => {
      //       return h("h1", [`${str}`]);
      //     },
      //   });
      return backNum;
    },
    /*
                参数：value 修改的时间
                作用：修改结束时间
            */
    SetEndTime(value) {
      this.endTime = value;
    },
    /*
                参数：value 修改的时间
                作用：修改开始时间
            */
    SetStartTime(value) {
      this.startTime = value;
    },
    /*
                参数：value 修改的时间间隔
                作用：修改查询间隔
            */
    SetStepTime(value) {
      this.alarmstepTime = value;
    },
    /*
                参数：value 修改报警类型的值
                作用：切换报警类型
            */
    UpDateAlarmType(value) {
      this.currentPage = 1;
      //切换实时或者历史需要给过滤关闭
      this.isFilter = false;
      //初始化过滤条件
      this.queries = [];
      this.queryList = [];
      value == "0" ? (this.alarmType = false) : (this.alarmType = true);
      // 类型是历史，则手动调用
      if (value == 1) {
        this.UpDateData();
      }
    },
    /*
                参数：condition 过滤条件 column 需要过滤的列
                作用：对报警信息进行过滤显示
            */
    AlarmFilter(condition, column) {
      //时间需要转换
      var arr = condition.split(".");
      condition = arr.join("/");
      this.isFilter = true;
      if (condition.length < 1) {
        this.isFilter = false;
      }
      if (column != "") {
        if (!~this.alarmLayout.findIndex((element) => element === column)) {
          this.$Message.info(
            this.$store.state.system.$.languageName == "ch"
              ? "请核对查询的列是否存在"
              : "Please verify that the queried column exists"
          );
          this.isFilter = false;
        }
      }
      this.queries = `${condition}`;
      this.queryList = `${column}`;
      //this.UpDateData();
    },

    /*
                参数：无
                作用：打印表单
            */
    Print() {
      if (this.nav()) {
        this.$Message.warning("手机以及ipad不支持表单打印!");
      } else {
        this.$Spin.show();
        var columnName = [];
        if (this.jsonData == undefined) return;
        for (var k in this.jsonData[0]) {
          columnName.push(k);
        }
        Print({
          printable: this.jsonData,
          properties: columnName,
          type: "json",
          onLoadingEnd: () => {
            this.$Spin.hide();
          },
        });
      }
    },
    /*
            数组对象完全相同的去除
            */
    delObj(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    audioPlay() {
      if (this.$refs.audio.paused) {
        if (navigator.userAgent.indexOf("Chrome") > -1) {
          if (this.openFlag == true) {
            var timers = null;
            clearTimeout(timers);
            timers = setTimeout(() => {
              this.$Modal.confirm({
                title: "系统",
                content: "<p>是否需要主动开启声音</p>",
                onOk: () => {
                  this.$refs.audio.pause();
                  this.$refs.audio.load();
                  this.$refs.audio.play();
                  // this.openFlag=false;
                },
              });
            }, 20);
            this.$Modal.props.zIndex.default = 8000;
            this.playFlag = false;
            this.openFlag = false;
          } else {
            this.$refs.audio.pause();
            this.$refs.audio.load();
            this.$refs.audio.play();
          }
        } else {
          this.$refs.audio.pause();
          this.$refs.audio.load();
          this.$refs.audio.play();
          this.playFlag = false;
          this.openFlag = false;
        }
      } else {
        this.$refs.audio.pause();
        this.$refs.audio.load();
        this.$refs.audio.play();
      }
    },
    /*转换数据*/
    transformation(data) {
      data.forEach((item) => {
        item.almId = this.fvSystemApi.getResource(item.almId) || item.almId;
        item.almPrio = this.fvSystemApi.getResource(item.almPrio) || item.almPrio;
        item.almGroup = this.fvSystemApi.getResource(item.almGroup) || item.almGroup;
        if (item.almTime != 0) {
          item.almTime = new Date(item.almTime).format("yyyy/MM/dd hh:mm:ss");
          item.startValue = Number(item.startValue).toFixed(3);
        } else {
          item.startValue = "-  -";
        }
        if (item.endTime != 0) {
          item.endTime = new Date(item.endTime).format("yyyy/MM/dd hh:mm:ss");
          item.endValue = Number(item.endValue).toFixed(3);
        } else {
          item.endTime = "-  -";
          item.endValue = "-  -";
        }
        if (item.ackTime != 0) {
          item.ackTime = new Date(item.ackTime).format("yyyy/MM/dd hh:mm:ss");
          item.ackValue = Number(item.ackValue).toFixed(3);
        } else {
          item.ackTime = "-  -";
          item.ackValue = "-  -";
        }
        item.tagName = this.fvSystemApi.getResource(item.tagName) || item.tagName;
        item.almDesc = this.fvSystemApi.getResource(item.almDesc) || item.almDesc;
        item.almRemark = this.fvSystemApi.getResource(item.almRemark) || item.almRemark;
        item.almInfo = this.fvSystemApi.getResource(item.almInfo) || item.almInfo;
        item.almStatus = this.fvSystemApi.getResource(item.almStatus) || item.almStatus;
        item.almComment =
          this.fvSystemApi.getResource(item.almComment) || item.almComment;
        item.almType = this.fvSystemApi.getResource(item.almType) || item.almType;
        if (item.almStatus == 0) {
          item.almStatus = this.fvSystemApi.getResource("未确认") || "未确认";
        } else if (item.almStatus == 1) {
          item.almStatus = this.fvSystemApi.getResource("确认") || "确认";
        } else if (item.almStatus == 2) {
          item.almStatus = this.fvSystemApi.getResource("恢复") || "恢复";
        } else if (item.almStatus == 3) {
          item.almStatus = this.fvSystemApi.getResource("已确认已恢复") || "已确认已恢复";
        } else {
          item.almStatus = this.fvSystemApi.getResource(" ") || " ";
        }
        var alarmLevel = item.almInfo.substring(0, item.almInfo.indexOf(":"));
        this.$set(item, "almLevel", alarmLevel);
      });
      return data;
    },
    //字符串判断包含
    existOneIncludeTwo(oneStr,twoStr) {
    // toUpperCase()：把字符串转换为大写
    // toLowerCase()：把字符串转换为小写 
    // return oneStr.toLowerCase().includes(twoStr.toLowerCase());
        return oneStr.toUpperCase().includes(twoStr.toUpperCase());
    },
    /*
                参数：无
                作用：更新数据
            */
    UpDateData() {
      if (this.loading) {
        // this.$Message.warning("请求中,请勿重复点击！");
        return;
      }
      var data = {};
      if (this.alarmType == true) {
        // 实时
        data = {
          head: "dataLayer",
          message: {
            head: "getSourceAlarm",
            message: {
              nodeName: "",
            },
          },
        };
        if (this.isRegion != 0) {
          // 区域查询
          data["message"]["message"]["nodeName"] = this.regionName;
        } else {
          this.fvSystemApi
            .getAlarmData(data)
            .then((result) => {
              this.loading = false;
              let resulrArr = [];
              var startResult = JSON.parse(JSON.stringify(result));
              this.transformation(result);
              this.transformation(startResult);
              if (this.AlmFilter[0].RealAlmFilter !== null) {
                if (this.AlmFilter[0].RealAlmFilter.length > 0) {
                  this.sa = null;
                  for (let i = 0; i < this.AlmFilter[0].RealAlmFilter.length; i++) {
                    resulrArr = [];
                    // this.AlmFilter[0].RealAlmFilter.map(function(value,index){
                    let FieldCondition = this.AlmFilter[0].RealAlmFilter[i].FieldCondition;

                    if (FieldCondition !== "") {
                      let FieldName = this.AlmFilter[0].RealAlmFilter[i].FieldName;
                      let fieldArr = FieldCondition.split(" ");
                      let firstarr = fieldArr;
                      let firstjudgment, secendjudgment;
                      if (fieldArr.indexOf("AND") !== -1) {
                        let firstStr = fieldArr[0];
                        let lastAndArr = fieldArr.slice(fieldArr.indexOf("AND") + 1);
                        //并且运算符lastAndArr[0]
                        let secendStr = lastAndArr[0];
                        lastAndArr.shift();
                        //并且过滤值lastAndArr.join("")

                        //运算符过滤值arr.join("")
                        let arr = firstarr.slice(0, firstarr.indexOf("AND"));
                        arr.shift();

                        if (this.sa != null) {
                          startResult = this.sa;
                        }
                        for (var index = 0; index < startResult.length; index++) {
                          if (secendStr == "=") {
                            secendjudgment = !(
                              startResult[index][FieldName] == lastAndArr.join("")
                            );
                          } else if (secendStr == ">") {
                            secendjudgment = !(
                              startResult[index][FieldName] > lastAndArr.join("")
                            );
                          } else if (secendStr == "<") {
                            secendjudgment = !(
                              startResult[index][FieldName] < lastAndArr.join("")
                            );
                          } else if (secendStr == ">=") {
                            secendjudgment = !(
                              startResult[index][FieldName] >= lastAndArr.join("")
                            );
                          } else if (secendStr == "<=") {
                            secendjudgment = !(startResult[index][FieldName] <= lastAndArr.join(""));
                          }else{
                            secendjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],lastAndArr.join("")));
                          }

                          // //运算符过滤值arr.join("")
                          // let arr = firstarr.slice(0, firstarr.indexOf("AND"));
                          // arr.shift();
                          //第一个判断运算符判断fieldArr[0]
                          if (firstStr == "=") {
                            firstjudgment = !(
                              startResult[index][FieldName] == arr.join("")
                            );
                          } else if (firstStr == ">") {
                            firstjudgment = !(
                              startResult[index][FieldName] > arr.join("")
                            );
                          } else if (firstStr == "<") {
                            firstjudgment = !(
                              startResult[index][FieldName] < arr.join("")
                            );
                          } else if (firstStr == ">=") {
                            firstjudgment = !(
                              startResult[index][FieldName] >= arr.join("")
                            );
                          } else if (firstStr == "<=") {
                            firstjudgment = !(
                              startResult[index][FieldName] <= arr.join("")
                            );
                          } else{
                            firstjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],arr.join("")));
                          }
                          if (!firstjudgment && !secendjudgment) {
                            resulrArr.push(startResult[index]);
                          }
                        }
                        this.sa = resulrArr;
                      } else {
                        //第一个判断运算符判断fieldArr[0]
                        let fieldstr = fieldArr[0];
                        fieldArr.shift();
                        //第一个判断运算符判断过滤值fieldArr.join("")

                        if (this.sa != null) {
                          startResult = this.sa;
                        }
                        for (var index = 0; index < startResult.length; index++) {
                          if (fieldstr == "=") {
                            //console.log(startResult[index][FieldName],fieldArr.join(""))
                            firstjudgment = !(
                              startResult[index][FieldName] == fieldArr.join("")
                            );
                          } else if (fieldstr == ">") {
                            firstjudgment = !(
                              startResult[index][FieldName] > fieldArr.join("")
                            );
                          } else if (fieldstr == "<") {
                            firstjudgment = !(
                              startResult[index][FieldName] < fieldArr.join("")
                            );
                          } else if (fieldstr == ">=") {
                            firstjudgment = !(
                              startResult[index][FieldName] >= fieldArr.join("")
                            );
                          } else if (fieldstr == "<=") {
                            firstjudgment = !(
                              startResult[index][FieldName] <= fieldArr.join("")
                            );
                          }else{
                            firstjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],fieldArr.join("")));
                          }
                          if (!firstjudgment) {
                            resulrArr.push(startResult[index]);
                          }
                        }
                        this.sa = resulrArr;
                      }
                    }
                    // })
                  }

                  // 对获取到的实时数据进行排序

                  let sortData = this.delObj(resulrArr).sort(this.NumAlarmSort);
                  sortData.forEach((value) => {
                    if (value.almId == undefined) {
                      value = null;
                    }
                  });
                  this.processingData(sortData);
                  if (this.alarmData.length > 0) {
                    for (let index = 0; index < this.alarmData.length; index++) {
                      const element = this.alarmData[index];
                      if (element.almStatus !== "确认") {
                        this.openAudio(sortData);
                      }
                    }
                  }
                } else {
                  // 对获取到的实时数据进行排序
                  let sortData = this.delObj(result).sort(this.NumAlarmSort);
                  this.processingData(sortData);
                  if (this.alarmData.length > 0) {
                    for (let index = 0; index < this.alarmData.length; index++) {
                      const element = this.alarmData[index];
                      if (element.almStatus !== "确认") {
                        this.openAudio(sortData);
                      }
                    }
                  }
                }
              } else {
                // 对获取到的实时数据进行排序
                let sortData = this.delObj(result).sort(this.NumAlarmSort);
                this.processingData(sortData);
                if (this.alarmData.length > 0) {
                  for (let index = 0; index < this.alarmData.length; index++) {
                    const element = this.alarmData[index];
                    if (element.almStatus !== "确认") {
                      this.openAudio(sortData);
                    }
                  }
                }
              }
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        }
      } else {
        this.loading = true;
        // 历史
        data = {
          head: "dataLayer",
          message: {
            head: "getSourceHisAlarm",
            message: {
              startTime: new Date(this.startTime).getTime(),
              endTime: new Date(this.endTime).getTime(),
              nodeName: "",
            },
          },
        };
        if (this.isRegion != 0) {
          // 区域查询
          data["message"]["message"]["nodeName"] = this.regionName;
        }

        this.fvSystemApi
          .getAlarmData(data)
          .then((result) => {
            this.loading = false;
            let resultArr = [];
            var startResult = JSON.parse(JSON.stringify(result));
            this.transformation(result);
            this.transformation(startResult);
            if (this.AlmFilter[1].HisAlmFilter !== null) {
              if (this.AlmFilter[1].HisAlmFilter.length > 0) {
                this.sa = null;
                for (let a = 0; a < this.AlmFilter[1].HisAlmFilter.length; a++) {
                  resultArr = [];
                  let FieldCondition = this.AlmFilter[1].HisAlmFilter[a].FieldCondition;
                  // this.AlmFilter[1].HisAlmFilter.map(function(value,index){
                  if (FieldCondition !== "") {
                    let FieldName = this.AlmFilter[1].HisAlmFilter[a].FieldName;
                    let fieldArr = FieldCondition.split(" ");
                    let firstarr = fieldArr;
                    let firstjudgment, secendjudgment;
                    if (fieldArr.indexOf("AND") !== -1) {
                      let firstStr = fieldArr[0];
                      let lastAndArr = fieldArr.slice(fieldArr.indexOf("AND") + 1);
                      //并且运算符lastAndArr[0]
                      let secendStr = lastAndArr[0];
                      lastAndArr.shift();
                      //并且过滤值lastAndArr.join("")
                      //运算符过滤值arr.join("")
                      let arr = firstarr.slice(0, firstarr.indexOf("AND"));
                      arr.shift();
                      if (this.sa != null) {
                        startResult = this.sa;
                      }
                      for (let index = 0; index < startResult.length; index++) {
                        if (secendStr == "=") {
                          secendjudgment = !(
                            startResult[index][FieldName] == lastAndArr.join("")
                          );
                        } else if (secendStr == ">") {
                          secendjudgment = !(
                            startResult[index][FieldName] > lastAndArr.join("")
                          );
                        } else if (secendStr == "<") {
                          secendjudgment = !(
                            startResult[index][FieldName] < lastAndArr.join("")
                          );
                        } else if (secendStr == ">=") {
                          secendjudgment = !(
                            startResult[index][FieldName] >= lastAndArr.join("")
                          );
                        } else if (secendStr == "<=") {
                          secendjudgment = !(startResult[index][FieldName] <= lastAndArr.join(""));
                        }else{
                          secendjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],lastAndArr.join("")));
                        }

                        //第一个判断运算符判断fieldArr[0]
                        if (firstStr == "=") {
                          firstjudgment = !(
                            startResult[index][FieldName] == arr.join("")
                          );
                        } else if (firstStr == ">") {
                          firstjudgment = !(startResult[index][FieldName] > arr.join(""));
                        } else if (firstStr == "<") {
                          firstjudgment = !(startResult[index][FieldName] < arr.join(""));
                        } else if (firstStr == ">=") {
                          firstjudgment = !(
                            startResult[index][FieldName] >= arr.join("")
                          );
                        } else if (firstStr == "<=") {
                          firstjudgment = !(startResult[index][FieldName] <= arr.join(""));
                        }else{
                          firstjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],arr.join("")));
                        }
                        if (!firstjudgment && !secendjudgment) {
                          resultArr.push(startResult[index]);
                        }
                      }
                      this.sa = resultArr;
                    } else {
                      //第一个判断运算符判断fieldArr[0]
                      let fieldstr = fieldArr[0];
                      fieldArr.shift();
                      //第一个判断运算符判断过滤值fieldArr.join("")
                      if (this.sa != null) {
                        startResult = this.sa;
                      }
                      for (let index = 0; index < startResult.length; index++) {
                        if (fieldstr == "=") {
                          firstjudgment = !(
                            startResult[index][FieldName] == fieldArr.join("")
                          );
                        } else if (fieldstr == ">") {
                          firstjudgment = !(
                            startResult[index][FieldName] > fieldArr.join("")
                          );
                        } else if (fieldstr == "<") {
                          firstjudgment = !(
                            startResult[index][FieldName] < fieldArr.join("")
                          );
                        } else if (fieldstr == ">=") {
                          firstjudgment = !(
                            startResult[index][FieldName] >= fieldArr.join("")
                          );
                        } else if (fieldstr == "<=") {
                          firstjudgment = !(startResult[index][FieldName] <= fieldArr.join(""));
                        } else{
                          firstjudgment = !(this.existOneIncludeTwo(startResult[index][FieldName],fieldArr.join("")));
                        }

                        if (!firstjudgment) {
                          resultArr.push(startResult[index]);
                        }
                      }
                      this.sa = resultArr;
                    }
                  }
                  // })
                }

                // 对获取到的实时数据进行排序
                let sortData = resultArr.sort(this.NumAlarmSort);
                sortData.forEach((value) => {
                  if (value.almId == undefined) {
                    value = null;
                  }
                });
                this.processingData(sortData);
                if (this.alarmData.length > 0) {
                  for (let index = 0; index < this.alarmData.length; index++) {
                    const element = this.alarmData[index];
                    if (element.almStatus !== "确认") {
                      this.openAudio(sortData);
                    }
                  }
                }
              } else {
                let objArr = result;
                // 对获取到的实时数据进行排序
                let sortData = this.delObj(objArr).sort(this.NumAlarmSort);
                this.processingData(sortData);
                if (this.alarmData.length > 0) {
                  for (let index = 0; index < this.alarmData.length; index++) {
                    const element = this.alarmData[index];
                    if (element.almStatus !== "确认") {
                      this.openAudio(sortData);
                    }
                  }
                }
              }
            } else {
              let objArr = result;
              // 对获取到的实时数据进行排序
              let sortData = this.delObj(objArr).sort(this.NumAlarmSort);
              this.processingData(sortData);
              if (this.alarmData.length > 0) {
                for (let index = 0; index < this.alarmData.length; index++) {
                  const element = this.alarmData[index];
                  if (element.almStatus !== "确认") {
                    this.openAudio(sortData);
                  }
                }
              }
            }
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    NumAlarmSort(a, b) {
      if (this.AlmSort == 1) {
        //0为降序，1为升序
        let item1 = this.AlmSortField[0];
        let item2 = this.AlmSortField[1];
        let item3 = this.AlmSortField[2];

        if (item1 !== "null") {
          return a[item1] - b[item1];
        }
        if (item2 !== "null") {
          return a[item2] - b[item2];
        }
        if (item3 !== "null") {
          return a[item3] - b[item3];
        }
        if (item1 == "null" && item2 == "null" && item3 == "null") {
          let time = new Date(a.almTime).getTime() - new Date(b.almTime).getTime();
          return time;
        }
      } else {
        if (this.AlmSortField[0] !== "null") {
          return b[this.AlmSortField[0]] - a[this.AlmSortField[0]];
        }
        if (this.AlmSortField[1] !== "null") {
          return b[this.AlmSortField[1]] - a[this.AlmSortField[1]];
        }
        if (this.AlmSortField[2] !== "null") {
          return b[this.AlmSortField[2]] - a[this.AlmSortField[2]];
        }
        if (
          this.AlmSortField[0] == "null" &&
          this.AlmSortField[1] == "null" &&
          this.AlmSortField[2] == "null"
        ) {
          let almTime = new Date(b.almTime).getTime() - new Date(a.almTime).getTime();
          return almTime;
        }
      }
    },
    /*属性*/
    _getAlmCount() {
      //获取确认,未恢复报警个数
      Object.defineProperty(this, "AckAlarmCount", {
        get: function () {
          let AckAlarmCount = 0;
          for (let index = 0; index < this.alarmData.length; index++) {
            let item = this.alarmData[index];
            if (item.almStatus == "确认") {
              AckAlarmCount++;
            }
          }
          return AckAlarmCount;
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:获取确认&恢复报警个数
      Object.defineProperty(this, "AckRestoreAlarmCount", {
        get: function () {
          let AckRestoreAlarmCount = 0;
          for (let index = 0; index < this.alarmData.length; index++) {
            let item = this.alarmData[index];
            if (item.almStatus == "已确认已恢复") {
              AckRestoreAlarmCount++;
            }
          }
          return AckRestoreAlarmCount;
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:获取所有报警个数
      Object.defineProperty(this, "AllAlarmCount", {
        get: function () {
          if (this.dataCount) {
            return this.dataCount;
          } else {
            return undefined;
          }
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:鼠标点击选中的单元格的列数
      Object.defineProperty(this, "CurCol", {
        get: function () {
          if (this.CurCol1) {
            return this.CurCol1;
          } else {
            return undefined;
          }
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:鼠标点击选中的单元格的行号
      Object.defineProperty(this, "CurRow", {
        get: function () {
          if (this.CurRow1) {
            return this.CurRow1;
          } else {
            return undefined;
          }
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:获取未确认,未恢复报警个数
      Object.defineProperty(this, "NoAckAlarmCount", {
        get: function () {
          let NoAckAlarmCount = 0;
          for (let index = 0; index < this.alarmData.length; index++) {
            let item = this.alarmData[index];
            if (item.almStatus == "未确认") {
              NoAckAlarmCount++;
            }
          }
          return NoAckAlarmCount;
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:获取未确认,恢复报警个数
      Object.defineProperty(this, "RestoreAlarmCount", {
        get: function () {
          let RestoreAlarmCount = 0;
          for (let index = 0; index < this.alarmData.length; index++) {
            let item = this.alarmData[index];
            if (item.almStatus == "恢复") {
              RestoreAlarmCount++;
            }
          }
          return RestoreAlarmCount;
        },
        set: function (value) {
          //console.error("");
        },
      });
      // 描述	:确认报警时是否选择报警处理措施
      Object.defineProperty(this, "SelectAlmOperation", {
        get: function () {
          for (let index = 0; index < this.alarmData.length; index++) {
            let item = this.alarmData[index];
            if (item.almStatus == "未恢复") {
              this.confirmAlarm();
              return item.almComment;
            }
          }
          // return RestoreAlarmCount;
        },
        set: function (value) {
          //console.error("");
        },
      });
    },
    /*方法*/
    // 确认全部报警信息
    AckAllAlarm() {
      var alarmIds = [];
      for (let index = 0; index < this.alarmData.length; index++) {
        if (this.alarmData[index].almStatus !== "确认") {
          alarmIds.push(this.alarmData[index].almId);
        }
      }
      var data = {
        head: "dataLayer",
        message: {
          head: "makeConfirmSourceAlarm",
          message: {
            head: "makeConfirm Alarm",
            ackName: this.fvSystemApi.getCurrentUser(),
            alarmIds: alarmIds,
          },
        },
      };
      this.fvSystemApi
        .getAlarmData(data)
        .then((result) => {
          this.UpDateData();
        })
        .catch((error) => {
          this.$Message.error("确认报警失败");
        });
      // 点击确认后先去修改颜色和数据
      //this.alarmData.splice(this.seletRowData.rowIndex, 1, this.seletRowData.rowData);
      //this.alarmData[this.seletRowData.rowIndex].almStatus = "修改中···";
      //this.$refs.tables.rowClassName(this.seletRowData.rowData, this.seletRowData.rowIndex);
    },
    // 函数描述:确认全部报警
    // 参数  	 :strOperation,报警处理措施
    AckAllAlarmEx(strOperation) {
      var alarmIds = [];
      for (let index = 0; index < this.alarmData.length; index++) {
        if (this.alarmData[index].almStatus !== "确认") {
          alarmIds.push(this.alarmData[index].almId);
          this.alarmData[index].almComment = strOperation;
        }
      }
      var data = {
        head: "dataLayer",
        message: {
          head: "makeConfirmSourceAlarm",
          message: {
            head: "makeConfirm Alarm",
            ackName: this.fvSystemApi.getCurrentUser(),
            alarmIds: alarmIds,
          },
        },
      };
      this.fvSystemApi
        .getAlarmData(data)
        .then((result) => {
          this.UpDateData();
        })
        .catch((error) => {
          this.$Message.error("确认报警失败");
        });
      // this.alarmData[this.seletRowData.rowIndex].almComment = strOperation;
    },
    // 确认选中报警信息
    AckSingleAlarm() {
      for (let index = 0; index < this.alarmData.length; index++) {
        return this.alarmData[index];
      }
    },
    // 函数描述:确认单个选中的报警
    // 参数  	:strOperation,报警处理措施
    AckSingleAlarmEx(strOperation) {
      //1，通过confirmAlarm确认单个报警
      //2, 当前选中的报警追加评论strOperation
      var alarmIds = [];
      // for (let index = 0; index < this.alarmData.length; index++) {
      if (this.alarmData[this.CurRow1].almStatus !== "确认") {
        alarmIds.push(this.alarmData[this.CurRow1].almId);
        this.alarmData[this.CurRow1].almComment = strOperation;
      }
      // }
      var data = {
        head: "dataLayer",
        message: {
          head: "makeConfirmSourceAlarm",
          message: {
            head: "makeConfirm Alarm",
            ackName: this.fvSystemApi.getCurrentUser(),
            alarmIds: alarmIds,
          },
        },
      };
      this.fvSystemApi
        .getAlarmData(data)
        .then((result) => {
          this.UpDateData();
        })
        .catch((error) => {
          this.$Message.error("确认报警失败");
        });
    },
    // 函数描述:增加报警处理措施提供给报警确认时选择
    // 参数  	:strOperation,报警处理措施
    AddAlmOperation(strOperation) {
      //1，参数赋值给this下的评论变量里
      let allid = [];
      for (let i = 0; i < this.alarmData.length; i++) {
        if (this.alarmData[i].almStatus !== "确认") {
          allid.push(this.alarmData[i].almId);
        }
      }
      var data = {
        head: "dataLayer",
        message: {
          head: "makeConfirmSourceAlarm",
          message: {
            head: "makeConfirm Alarm",
            ackName: this.fvSystemApi.getCurrentUser(),
            alarmIds: allid,
          },
        },
      };
      this.fvSystemApi
        .getAlarmData(data)
        .then((result) => {
          this.UpDateData();
        })
        .catch((error) => {
          this.$Message.error("确认报警失败");
        });
      for (let index = 0; index < this.alarmData.length; index++) {
        this.alarmData[index].almComment = strOperation;
      }
    },
    // 函数描述:报警导出到excel
    // 参数  	:nMode:是否带有文件路径选择对话框 0:无 1:有
    // 	         strFilePath:文件路径,当nMode为0是有效
    AlarmExportToExcel(nMode, strFilePath) {
      alert("暂不支持指定路径保存");
      strFilePath = strFilePath.substring(
        strFilePath.lastIndexOf("\\") + 1,
        strFilePath.length
      );
      this.$Modal.confirm({
        title: "系统",
        content: "<p>您确定下载保存excel文件吗</p>",
        onOk: () => {
          this.ExportToExcel(strFilePath);
        },
      });
      //1，通过参数把当前的报警导出到excel中
      //2,如果pc端无excel无法导出，则导出为csv文件，文件路径依据参数2来保存，文件名依据参数1选择的命名
    },
    ExportToExcel(excelName) {
      require.ensure([], () => {
        const tHeader = [];
        const excelValue = [];
        const excelData = this.alarmData;
        const {
          export_json_to_excel,
        } = require("../../../assets/exportExcel/Export2Excel"); //注意这个Export2Excel路径
        // this.children[0]
        this.alarmLayout.forEach((item) => {
          if (this.AutoSizeColumn == 1) {
            let str = item.slice(0, item.lastIndexOf("_"));
            let valueItem = str.substring(str.lastIndexOf("_") + 1, str.length);
            item = str.substring(0, str.lastIndexOf("_"));
            tHeader.push(item);
            excelValue.push(valueItem);
          } else {
            let valueItem = item.substring(item.lastIndexOf("_") + 1, item.length); //obj.width
            let str = item.slice(0, item.lastIndexOf("_"));
            let keyText = str.substring(str.lastIndexOf("_") + 1, str.length);
            str = str.substring(0, str.lastIndexOf("_"));
            tHeader.push(str);
            excelValue.push(keyText);
          }
        });

        const data = this.formatJson(excelValue, excelData); //把要导出的数据存到list,上面的index、nickName、name是对象的属性key值
        export_json_to_excel(tHeader, data, excelName); //最后一个是表名字
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 函数描述:打印报警信息
    AlarmPrint() {
      this.Print();
    },
    // 函数描述:报警排序
    // 参数  	:nSortType - 整型数,1表示降序,0表示升序
    // 	 strSortFirst - 字符串，排序字段 如："无","优先级","开始时间"等
    // 	 strSortSecond - 字符串，排序字段 如："无","优先级","开始时间"等
    // 	 strSortThird - 字符串，排序字段 如："无","优先级","开始时间"等
    // 说明  	:报警按升序或降序进行排列(指针对实时报警)以strSortFirst,strSortSecond,strSortThird中的一种为主
    // 示例  	:#FCAlarm.AlarmSort(0,"开始时间","无","无");
    // 报警按升序排列，并且是按照排序一中的级别进行排序
    AlarmSort(nSortType, strSortFirst, strSortSecond, strSortThird) {
      //按照参数报警排序
      this.AlmSort = nSortType;
      this.alarmLayout.forEach((item) => {
        if (this.AutoSizeColumn == 1) {
          let str = item.slice(0, item.lastIndexOf("_"));
          let valueItem = str.substring(str.lastIndexOf("_") + 1, str.length);
          item = str.substring(0, str.lastIndexOf("_"));
          if (strSortFirst == item) {
            strSortFirst = valueItem;
          } else {
            strSortFirst = "null";
          }
          if (strSortSecond == item) {
            strSortSecond = valueItem;
          } else {
            strSortSecond = "null";
          }
          if (strSortThird == item) {
            strSortThird = valueItem;
          } else {
            strSortThird = "null";
          }
        } else {
          let valueItem = item.substring(item.lastIndexOf("_") + 1, item.length); //obj.width
          let str = item.slice(0, item.lastIndexOf("_"));
          let keyText = str.substring(str.lastIndexOf("_") + 1, str.length);
          str = str.substring(0, str.lastIndexOf("_"));
          if (strSortFirst == str) {
            strSortFirst = keyText;
          } else {
            strSortFirst = "null";
          }
          if (strSortSecond == str) {
            strSortSecond = keyText;
          } else {
            strSortSecond = "null";
          }
          if (strSortThird == str) {
            strSortThird = keyText;
          } else {
            strSortThird = "null";
          }
        }
      });
      this.AlmSortField = [strSortFirst, strSortSecond, strSortThird];
    },
    // 函数描述:清除报警过滤条件
    // 参数    :nMode: 0:实时 1:历史
    DeleteAlarmFiler(nMode) {
      //1,通过nMode参数类型删除对应条件下的过滤条件:0:实时 RealAlmFilter、 1:历史 HisAlmFilter
      if (nMode == 0) {
        this.AlmFilter[0].RealAlmFilter = [];
      } else {
        this.AlmFilter[1].HisAlmFilter = [];
      }
    },
    //函数描述:根据当前报警类型设置过滤条件。
    SetAlarmConfig() {
      if (this.alarmType == false) {
        this.AlmFilter[1].HisAlmFilter = this.AlmFilter[1].HisAlmFilter;
      } else {
        this.AlmFilter[0].RealAlmFilter = this.AlmFilter[0].RealAlmFilter;
      }
    },
    // 函数描述:获得报警类型
    // 返回值  :0 实时报警 1 历史报警
    GetAlarmType() {
      var str = "";
      var backNum;
      if (this.alarmType == false) {
        str = "历 史 报 警";
        backNum = 1;
      } else {
        str = "实 时 报 警";
        backNum = 0;
      }
      //注释掉，暂时不知道用途
      this.$Notice.success({
        title: "当前报警类型为:",
        desc: `${str}`,
        render: (h) => {
          return h("h1", [`${str}`]);
        },
      });
      return backNum;
    },
    // 函数描述:获取指定单元格中的内容(行列号均从1开始计数)
    // 返回值	:string 单元格中的内容
    // 参数  	:nRow - 整型数，指定单元格的行号，基于0
    //         nCol - 整型数，指定单元格的列号，基于0
    GetCellText(nRow, nCol) {
      //1,指定单元格中的内容
      //产生随机字母

      let arr = this.alarmData[nRow];
      let array = [];

      let j = 0;

      for (var key in arr) {
        array[j] = arr[key];

        j++;
      }
      return array[nCol];
    },
    //生成随机数
    getRanNum() {
      var result = [];
      for (var i = 0; i < 4; i++) {
        var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
        //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
        result.push(String.fromCharCode(65 + ranNum));
      }
      return result.join("");
    },
    // 函数描述:获得当前选中的列
    // 返回值	:(int）
    GetCurCol() {
      //1,当前选中的列
      return this.CurCol1;
    },
    // 函数描述:获得当前选中的行
    // 返回值	:(int）
    GetCurRow() {
      return this.CurRow1;
    },
    // 函数描述:获取历史查询起始时间
    // 返回值	:(int)
    GetHisAlarmBeginTime() {
      //当前历史开始时间，返回时间戳
      if (this.alarmType == false) {
        return new Date(this.alarmData[this.CurRow1].almTime).getTime();
      } else {
        this.$Message.info("目前是实时报警,建议切换历史报警查询");
      }
    },
    // 函数描述:获取历史查询结束时间
    // 返回值	:(int)
    GetHisAlarmEndTime() {
      //当前历史结束时间，返回时间戳
      if (this.alarmType == false) {
        return new Date(this.alarmData[this.CurRow1].endTime).getTime();
      } else {
         this.$Message.info("目前是实时报警,建议切换历史报警查询");
      }
    },
    // 函数描述:查询历史状态下某点名产生的报警
    // 返回值 :int
    // 参数   :csFlagTagName 点名
    GetTagNameCount(csFlagTagName) {
      //1,通过json中传入的startTime，endTime获取历史报警
      //2,过滤出参数点名下的报警个数返回
      if (this.alarmType == false) {
        let count = 0;
        for (let index = 0; index < this.alarmData.length; index++) {
          const element = this.alarmData[index];
          if (element.tagName == csFlagTagName) {
            count++;
          }
        }
        return count;
      } else {
         this.$Message.info("目前是实时报警,建议切换历史报警查询");
      }
    },

    // 函数描述:函数描述:查询历史报警
    // 返回值 :void
    // 参数  	:nBeginTime、nEndTme 历史报警的起始和结束时间,值为1970年1月1日到现在的秒数
    // 	 可以用日期控件方法GetTime()得到,szCond 过滤条件字符串
    // 说明  	:查询历史报警的时间间隔不能超过30天，多个过滤条件以逗号分隔，一个过滤
    // 	 条件格式如下 (字段名 操作符 过滤值 连接符 操作符 过滤值)
    // 	 可以不使用连接符 即表示只有一个条件，使用的话，连接符现只有一个,
    // 	 即and,其前后用空格隔开中间不能有空格,否则匹配错误。
    // 	 字段名、操作符、过滤值 用空格分开。过滤字符串举例如下
    // 	 "位号 = a1,类型 = 低5报,级别 > 3 and <= 25"
    // 	 字段名请与报警字段配置中一致.否则查询匹配不到.
    // 	 数值、限值、级别、报警组 支持 > < >= <= = <>,其他类型字段仅支持 = 操作符
    // 	 实时和历史所支持的过滤字段不一样,请与报警配置中过滤字段一致
    // 	 注意该函数会将原有条件替换掉.
    QueryHisAlarmByCond(nBeginTime, nEndTme, szCond) {
      if (this.alarmType == false) {
        this.startTime = nBeginTime;
        this.endTime = nEndTme;
        let fieldArr = szCond.split(" ");
        let first = fieldArr[0];
        this.alarmLayout.forEach((item) => {
          if (this.AutoSizeColumn == 1) {
            let str = item.slice(0, item.lastIndexOf("_"));
            let valueItem = str.substring(str.lastIndexOf("_") + 1, str.length);
            item = str.substring(0, str.lastIndexOf("_"));
            if (first == item) {
              first = valueItem;
            }
          } else {
            let valueItem = item.substring(item.lastIndexOf("_") + 1, item.length); //obj.width
            let str = item.slice(0, item.lastIndexOf("_"));
            let keyText = str.substring(str.lastIndexOf("_") + 1, str.length);
            str = str.substring(0, str.lastIndexOf("_"));
            if (first == str) {
              first = keyText;
            }
          }
        });
        fieldArr.shift();
        let obj = {
          FieldName: first,
          FieldCondition: fieldArr.join(" "),
        };
        this.AlmFilter[1].HisAlmFilter = [];
        this.AlmFilter[1].HisAlmFilter.push(obj);
      } else {
         this.$Message.info("目前是实时报警,建议切换历史报警查询");
      }

      //1,通过nBeginTime、nEndTme获取所有历史报警
      //2,通过szCond字段进行过滤
      //最后调用UpDateData
    },

    // 函数描述:使用当前过滤条件查询历史报警
    // 参数  	:nBeginTime、nEndTme 历史报警的起始和结束时间 值为1970年1月1日到现在的秒数
    QueryHisAlarmByTime(nBeginTime, nEndTme) {
      //1,通过nBeginTime、nEndTme获取所有历史报警
      //2,通过HisAlmFilter字段进行过滤
      if (this.alarmType == false) {
        this.startTime = nBeginTime;
        this.endTime = nEndTme;
      } else {
         this.$Message.info("目前是实时报警,建议切换历史报警查询");
      }
      //最后调用UpDateData
    },
    // 函数描述:播放指定WAV文件的报警或锋鸣
    PlaySound() {
      //1,路径必须为smartwork 工程目录下的img才能读取文件？
      //    alert("qqqq")
      this.OpenPlaySound = 1;
      //最后调用UpDateData
    },
    // 函数描述:查询实时报警
    // 参数  	:szCond 过滤条件字符串
    // 说明  	:多个过滤条件以逗号分隔，一个过滤
    // 	 条件格式如下 (字段名 操作符 过滤值 连接符 操作符 过滤值)
    // 	 可以不使用连接符 即表示只有一个条件，使用的话，连接符现只有一个
    // 	 即and,其前后用空格隔开中间不能有空格,否则匹配错误。
    // 	 字段名、操作符、过滤值 用空格分开。过滤字符串举例如下
    // 	 "位号 = a1,类型 = 低5报,级别 > 3 and <= 25"
    // 	 字段名请与报警字段配置中一致.否则查询匹配不到.
    // 	 数值、限值、级别、报警组 支持 > < >= <= = <>,其他类型字段仅支持 = 操作符
    // 	 实时和历史所支持的过滤字段不一样,请与报警配置中过滤字段一致
    //    注意该函数会将原有条件替换掉
    QueryRealAlarmByCond(szCond) {
      //1，获取全部报警后通过szCond进行过滤刷选
      if (this.alarmType == true) {
        let fieldArr = szCond.split(" ");
        let first = fieldArr[0];
        this.alarmLayout.forEach((item) => {
          if (this.AutoSizeColumn == 1) {
            let str = item.slice(0, item.lastIndexOf("_"));
            let valueItem = str.substring(str.lastIndexOf("_") + 1, str.length);
            item = str.substring(0, str.lastIndexOf("_"));
            if (first == item) {
              first = valueItem;
            }
          } else {
            let valueItem = item.substring(item.lastIndexOf("_") + 1, item.length); //obj.width
            let str = item.slice(0, item.lastIndexOf("_"));
            let keyText = str.substring(str.lastIndexOf("_") + 1, str.length);
            str = str.substring(0, str.lastIndexOf("_"));
            if (first == str) {
              first = keyText;
            }
          }
        });
        fieldArr.shift();
        let obj = {
          FieldName: first,
          FieldCondition: fieldArr.join(" "),
        };
        this.AlmFilter[0].RealAlmFilter.push(obj);
      } else {
        this.$Message.info("目前是历史报警,建议切换实时报警查询");
      }
      //最后调用UpDateData
    },
    // 函数描述:设置报警类型
    // 参数  	:ntype 0 实时报警 1 历史报警
    SelectAlarmType(ntype) {
      if (ntype == 0) {
        this.alarmType = true;
      } else if (ntype == 1) {
        this.alarmType = false;
      }
      // this.alarmType = ntype;
    },
    // 函数描述:设置为消音模式
    SetMuffle() {
      if (!this.$refs.audio.paused) {
        this.$refs.audio.pause();
      }
    },
    /*------------------------------------脚本在上---------------------------------------------*/
    /*------------------------------------方法在下---------------------------------------------*/
    /*
                参数：data 数据
                作用：是否开启声音
            */
    playEndedHandler() {
      var a = this.arr.pop();
      this.arr.unshift(a);
      this.$refs.audio.src = a;
      this.$refs.audio.play();
    },

    openAudio(data) {
      if (this.isEnable || !this.isShow) {
        if (!this.$refs.audio.paused) this.$refs.audio.pause();
        return;
      }
      if (this.OpenPlaySound == 1) {
        this.playFlag = true;
        // var openFlag=true;
        if (this.AlmPlaySound !== null && this.playFlag == true) {
          //遍历所有返回的报警信息
          this.audioPlay();
          this.arr = new Array(data.length);
          for (var i = 0; i < data.length; i++) {
            let almItem = data[i]; //当前报警项
            if (this.AlmPlaySound[0].almPrio !== null) {
              for (var j = 0; j < this.AlmPlaySound[0].almPrio.length; j++) {
                if (almItem.almPrio == this.AlmPlaySound[0].almPrio[j].nPrio) {
                  // this.arr.unshift(
                  //   debugFWebView +
                  //     this.$store.state.system.$.projectName +
                  //     "/img/" +
                  //     this.AlmPlaySound[0].almPrio[j].audioName
                  // );
                  this.arr[i] =
                    debugFWebView +
                    this.$store.state.system.$.projectName +
                    "/img/" +
                    this.AlmPlaySound[0].almPrio[j].audioName;
                }
              }
            } else if (this.AlmPlaySound[1].almTag !== null) {
              for (var k = 0; k < this.AlmPlaySound[1].almTag.length; k++) {
                if (almItem.tagName.replace(/\\/gi,".") == this.AlmPlaySound[1].almTag[k].tagName.replace(/.PV/gi,"")) {
                  this.arr[i] =
                    debugFWebView +
                    this.$store.state.system.$.projectName +
                    "/img/" +
                    this.AlmPlaySound[1].almTag[k].audioName;
                }
              }
            }
            // 如果音频在播放下面的状态则为false 则使音频停止播放
          }
          if (this.arr.length !== 0) {
            var a = this.arr.pop();
            this.arr.unshift(a);
            if (a !== "" || a !== undefined || a !== null) {
              this.$refs.audio.src = a; //每次读数组最后一个元素
              let playPromise = this.$refs.audio.play();
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    this.$refs.audio.addEventListener(
                      "ended",
                      this.playEndedHandler,
                      false
                    );
                    this.$refs.audio.loop = false; //禁止循环，否则无法触发ended事件
                  })
                  .catch(() => {});
              }
            }
          }
        } else {
          //不需要提示是否配置，根据组件属性信息读取
          //this.$Message.warning("请设置报警声音!");
        }
      }
    },
    /*
                参数：index 当前页数
                作用：切换分页
            */
    changepage(index) {
      if (this.temporaryData != undefined) {
        this.currentPage = index;
        this.dataCount = this.temporaryData.length;
        var _start = (index - 1) * this.pageSize;
        var _end = index * this.pageSize;
        var data = this.temporaryData.slice(_start, _end);
        this.showAlarmData(data);
      }
    },
    /*
                参数：data 转换为展示数据
                作用：为实时数据的展示进行转换
            */
    processingData(data) {
      if (this.isFilter) {
        var data = this.filterMethod(data);
      }
      this.temporaryData = data;
      var page = Math.floor((this.tableHeight - 32) / 40);
      this.pageSize = page > 1 ? page : 1;
      this.changepage(this.currentPage);
    },
    /*
                参数：data 展示用数据
                作用：将数据进行展示
            */
    showAlarmData(data) {
      this.alarmData = data;
      this.jsonData = JSON.parse(JSON.stringify(data));
      this.disposePrintData(this.jsonData);
    },
    /*
                参数：无
                作用：更新表头
            */
    setColumnsData() {
      if (this.alarmLayout == null) return;
      this.columns.splice(0);
      this.alarmLayout.forEach((item) => {
        if (this.AutoSizeColumn == 1) {
          let str = item.slice(0, item.lastIndexOf("_"));
          let valueItem = str.substring(str.lastIndexOf("_") + 1, str.length);
          item = str.substring(0, str.lastIndexOf("_"));

          let obj = {
            title: item,
            align: "center",
          };
          if (item) {
            obj.key = valueItem;
            obj.width = 150;
          }
          this.columns.push(obj);
        } else {
          let valueItem = item.substring(item.lastIndexOf("_") + 1, item.length); //obj.width
          let str = item.slice(0, item.lastIndexOf("_"));
          let keyText = str.substring(str.lastIndexOf("_") + 1, str.length);
          str = str.substring(0, str.lastIndexOf("_"));
          let obj = {
            title: str,
            align: "center",
          };
          if (str) {
            obj.key = keyText;
            obj.width = valueItem;
          }
          this.columns.push(obj);
        }
      });
      var tableWidth = 0;
      this.columns.forEach((el) => {
        tableWidth += el.width;
      });
      if (tableWidth < this.realWidth) {
        this.columns.forEach((el) => {
          delete el.width;
        });
      }
    },
    /*
                参数：无
                作用：控制class样式绑定为变量
            */
    func() {
      if (this.transparent == 1) {
        this.transparent = true;
      } else {
        this.transparent = false;
      }
      var n = 0;
      this.transparent ? (n = 0.2) : (n = 1);

      this.$refs.mycolor.style.setProperty(
        "--unbgColor",
        this.colorRgba(this.colorType[0], n) //未确认
      );
      this.$refs.mycolor.style.setProperty(
        "--reunbgColor",
        this.colorRgba(this.colorType[1], n) //确认
      );
      this.$refs.mycolor.style.setProperty(
        "--bgColor",
        this.colorRgba(this.colorType[3], n) //已确认已恢复
      );
      this.$refs.mycolor.style.setProperty(
        "--rebgColor",
        this.colorRgba(this.colorType[2], n) //恢复
      );
      this.$refs.mycolor.style.setProperty("--unColor", this.colorTextType[0]); //未确认
      this.$refs.mycolor.style.setProperty("--reunColor", this.colorTextType[1]); //确认
      this.$refs.mycolor.style.setProperty("--Color", this.colorTextType[3]); //已确认已恢复
      this.$refs.mycolor.style.setProperty("--reColor", this.colorTextType[2]); //恢复
      //背景颜色
      this.$refs.mycolor.style.setProperty(
        "--thColor",
        this.colorRgba(this.tableBackgroundColor, n)
      );
      //字体颜色
      this.$refs.mycolor.style.setProperty("--textColor", this.tableTextColor);
      this.$refs.mycolor.style.setProperty(
        "--tableColor",
        this.transparent ? "transparent" : "#f8f8f9"
      );
      this.$refs.mycolor.style.setProperty("--borderColor", this.borderColor);
    },
    /*
                参数：row 当前数据 index  下标
                作用：根据条件改变行内颜色
            */
    rowClassName(row, index) {
      if (row.almStatus == "未确认") {
        return "demo-table-unConfirm-row";
      } else if (row.almStatus == "确认") {
        return "demo-table-unRecovery-row";
      } else if (row.almStatus == "恢复") {
        return "demo-table-recovery-row";
      } else if (row.almStatus == "已确认已恢复") {
        return "demo-table-confirm-row";
      } else {
        return "";
      }
    },
    /*
                参数：row 当前数据 index 下标
                作用：双击表单事件
            */
    doblueClick(row, index) {
      clearTimeout(this.timer);
      this.CurRow1 = index;
      //产生随机字母
      let ranNum = this.getRanNum();
      //给domo节点添加class
      this.$el.children[1].className += " " + ranNum;
      $(`.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr td`)
        .siblings("td")
        .removeClass("selected"); // 删除其他兄弟元素的样式

      $(
        `.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr:nth-child(${
          index + 1
        }) td:nth-child(${this.CurCol1 + 1})`
      ).addClass("selected");
      //   $(`.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr:nth-child(${index+1}) td:nth-child(${this.CurCol1+1})`).append(`<style>.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr:nth-child(${index+1}) td:nth-child(${this.CurCol1+1}){border:1px solid red !important}</style>`);
      this.timer = setTimeout(() => {
        //在单击事件中添加一个setTimeout()函数，设置单击事件触发的时间间隔
        // this.$set(row, "_highlight", true);
        // 存储下双击过的数据
        this.seletRowData = {
          rowData: row,
          rowIndex: index,
        };
        this.singleAlarmData = [];
        this.column = [];
        if (
          row.almStatus == "未确认" ||
          row.almStatus == this.fvSystemApi.getResource("未确认")
        ) {
          row.user = this.fvSystemApi.getCurrentUser();
          row.ackTime = new Date(new Date().getTime()).format("yyyy/MM/dd hh:mm:ss");
          row.userId = "未确认";
          this.singleAlarmData.push(row);
          for (var i = 0; i < this.columns.length; i++) {
            var item = this.columns[i];
            var key = item.key;
            if (key) {
              this.column.push(item);
            }
          }
          if (row.alarmAudio) {
            this.column.push({});
          }
          this.alarmModal = true;
        }
      }, 300);
      $(
        `.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr:nth-child(${
          index + 1
        }) td:nth-child(${this.CurCol1 + 1})`
      ).append(
        `<style>.${ranNum} .ivu-table-wrapper .ivu-table .ivu-table-body tr td{border:0px solid red !important}</style>`
      );
    },
    /*
                获取单元格信息
            */
    cellClick(row, column, data, event) {
      this.CurCol1 = column._index;
      this.CurRow1 = row._index;
    },
    /*
                双击停止
            */
    doubleClickAck(row, index) {
      clearTimeout(this.timer);
      this.seletRowData = {
        rowData: row,
        rowIndex: index,
      };
      this.singleAlarmData = [];
      this.column = [];
      if (
        row.almStatus !== "确认" ||
        row.almStatus !== this.fvSystemApi.getResource("确认")
      ) {
        row.user = this.fvSystemApi.getCurrentUser();
        row.ackTime = new Date(new Date().getTime()).format("yyyy/MM/dd hh:mm:ss");
        row.userId = "未确认";
        this.singleAlarmData.push(row);
        for (var i = 0; i < this.columns.length; i++) {
          var item = this.columns[i];
          var key = item.key;
          if (key) {
            this.column.push(item);
          }
        }
        if (row.alarmAudio) {
          this.column.push({});
        }
      }
      if (this.singleAlarmData[0].user != "") {
        var data = {
          head: "dataLayer",
          message: {
            head: "makeConfirmSourceAlarm",
            message: {
              head: "makeConfirm Alarm",
              ackName: this.singleAlarmData[0].user,
              alarmIds: [parseInt(this.singleAlarmData[0].almId)],
            },
          },
        };
        this.fvSystemApi
          .getAlarmData(data)
          .then((result) => {
            this.UpDateData();
          })
          .catch((error) => {
            this.$Message.error("确认报警失败");
          });
        if (this.AckStopPlay == 1) {
          this.$refs.audio.pause();
          this.$refs.audio.load();
        }
        //点击确认后先去修改颜色和数据
        this.alarmData.splice(this.seletRowData.rowIndex, 1, this.seletRowData.rowData);
        this.alarmData[this.seletRowData.rowIndex].almStatus = "修改中···";
        this.$refs.tables.rowClassName(
          this.seletRowData.rowData,
          this.seletRowData.rowIndex
        );
      } else {
        this.$Message.error("确认人不能为空！");
      }
    },
    /*
                参数：无
                作用：确认报警人
            */
    confirmAlarm() {
      this.alarmModal = false;
      if (this.singleAlarmData[0].user != "") {
        var data = {
          head: "dataLayer",
          message: {
            head: "makeConfirmSourceAlarm",
            message: {
              head: "makeConfirm Alarm",
              ackName: this.singleAlarmData[0].user,
              alarmIds: [parseInt(this.singleAlarmData[0].almId)],
            },
          },
        };
        this.fvSystemApi
          .getAlarmData(data)
          .then((result) => {
            this.UpDateData();
          })
          .catch((error) => {
            this.$Message.error("确认报警失败");
          });
        if (this.AckStopPlay == 1) {
          this.$refs.audio.pause();
          this.$refs.audio.load();
        }
        //点击确认后先去修改颜色和数据
        this.alarmData.splice(this.seletRowData.rowIndex, 1, this.seletRowData.rowData);
        this.alarmData[this.seletRowData.rowIndex].almStatus = "修改中···";
        this.$refs.tables.rowClassName(
          this.seletRowData.rowData,
          this.seletRowData.rowIndex
        );
      } else {
        this.$Message.error("确认人不能为空！");
      }
    },
    /*
                参数：无
                作用：取消确认报警弹窗
            */
    unConfirmAlarm() {
      this.alarmModal = false;
    },
    /*
                参数：data 需要过滤的数据
                作用：将数据进行过滤展示
            */
    filterMethod(data) {
      var filterData = [];
      if (data.length != 0) {
        // 查询固定列
        if (this.queryList.length != "") {
          data.forEach((item) => {
            this.columns.forEach((list) => {
              if (list.title == this.queryList) {
                if (item[list.key].indexOf(this.queries) != -1) {
                  filterData.push(item);
                }
              }
            });
          });
        } else {
          // 查询所有列
          data.forEach((item) => {
            var overCycle = true;
            this.columns.forEach((list) => {
              if (overCycle) {
                if (list.key) {
                  // 把数据转换为字符串
                  var str = item[list.key] + "";
                  if (str.indexOf(this.queries) != -1) {
                    filterData.push(item);
                    overCycle = false;
                  }
                }
              }
            });
          });
        }
      }
      return filterData;
    },
    /*
                参数：data 需要转换的数据
                作用：将数据转化为打印格式
            */
    disposePrintData(data) {
      var reg = /^[a-zA-Z]+$/;
      data.forEach((item) => {
        this.columns.forEach((list) => {
          if (list.key) {
            for (var k in item) {
              if (k == list.key) {
                item[list.title] = item[k];
              }
            }
          }
        });
        for (var z in item) {
          if (reg.test(z)) {
            delete item[z];
          }
        }
      });
    },
    /*
                参数：无
                作用：判断是否支持导出的设备
            */
    nav() {
      var ua = navigator.userAgent;
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
      if (isIphone || isAndroid || isMobile) {
        return true;
      } else {
        return false;
      }
    },
    /*
                参数：str 十六位制颜色 n 透明度
                作用：将十六位制的颜色转为rgba
            */
    colorRgba(str, n) {
      if (!str) return;
      //十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = str.toLowerCase();
      //十六进制颜色转换为RGB格式
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            //例如：#eee,#fff等
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return "rgba(" + sColorChange.join(",") + "," + n + ")";
      } else {
        return sColor;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvFcAlarmReport/fvFcAlarmReport.vue